//ASSIGNMENT CONFIRMATION OPTIONS
export const assignmentConfirmationOptions = [
  {
    key: "true",
    text: "Yes",
  },
  {
    key: "false",
    text: "No",
  },
];

//RADIOLOGIST TIME SPENT OPTIONS
export const radiologistTimeSpentOptions = [
  {
    key: "true",
    text: "Yes",
  },
  {
    key: "false",
    text: "No",
  },
];

//STATUS OPTIONS
export const activeStatusOptions = [
  {
    key: "true",
    text: "Active",
  },
  {
    key: "false",
    text: "Inactive",
  },
];
//Account locked option
export const userAccountOptions = [
  {
    key: "true",
    text: "Active",
  },
  {
    key: "false",
    text: "Locked",
  },
];

//RADIOLOGIST TYPE OPTIONS
export const radiologistTypeOptions = [
  {
    key: 1,
    text: "Panel",
  },
  {
    key: 2,
    text: "Expert",
  },
  {
    key: 3,
    text: "Customer",
  },
];

export const viewerForNonXRAYOptions = [
  {
    key: 1,
    text: "Basic Viewer",
  },
  {
    key: 2,
    text: "Advanced Viewer",
  }
];

export const studylistDateSearchFilter = [
  {
    key: 1,
    text: "Study Date",
  },
  {
    key: 2,
    text: "Report Date",
  }
];
